export default class DateUtils {
  static daysDiff(date1: Date, date2: Date): number {
    const secondsDiff = DateUtils.secondsDiff(date1, date2);
    if (secondsDiff >= 86400) {
      return Math.floor(secondsDiff / 86400)
    } else {
      return 0;
    }
  }

  static secondsDiff(date1: Date, date2: Date): number {
    return (date2.getTime() - date1.getTime()) / 1000
  }

  static isInThePast(date: Date): boolean {
    return date < DateUtils.getNowAsDate();
  }

  static addDays(date: Date, days: number): Date { //TODO test
    const dat = new Date(date.valueOf());
    dat.setDate(dat.getDate() + days);
    return dat;
  }

  static getNowAsDate(): Date { //TODO test
    const date = new Date();
    date.setDate(date.getDate());
    date.setHours(0, 0, 0, 0);
    return date;
  }

  static getNowAsTimeStamp(): Date { //TODO test
    return new Date();
  }

  static addDaysToNowAsDate(days: number) { //TODO test
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + days);
    return date;
  }

  static addMinutesToNowAsTimeStamp(hours: number) { //TODO test
    const date = new Date();
    date.setHours(date.getHours() + hours);
    return date;
  }

  static addMonthsToNowAsDate(months: number): Date { //TODO test
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    date.setMonth(date.getMonth() + months);
    return date;
  }

  static toString(dateValue: Date): string {
    const d = dateValue.getDate();
    const m = dateValue.getMonth() + 1;
    const y = dateValue.getFullYear();
    return (d <= 9 ? '0' + d : d) + '/' + (m <= 9 ? '0' + m : m) + '/' + y;
  }

  static toBackendFormattedString(dateValue: Date): string {
    const d = dateValue.getDate();
    const m = dateValue.getMonth() + 1;
    const y = dateValue.getFullYear();
    return y + '-' + (m <= 9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
  }

  static fromStringToDate(stringValue: string): Date | undefined {
    const matchesArray = stringValue.match(/([0-9]{4})-([0-9]{2})-([0-9]{2}).*/i);
    if (matchesArray) {
      const date = new Date(Number(matchesArray[1]), Number(matchesArray[2]) - 1, Number(matchesArray[3]));
      date.setHours(0, 0, 0);
      return date;
    } else {
      return undefined;
    }
  }

  static fromStringToDateTime(stringValue: string): Date | undefined {
    const matchesArray = stringValue.match(/([0-9]{4})-([0-9]{2})-([0-9]{2}) ([0-9]{2}):([0-9]{2}):([0-9]{2}).*/i);
    if (matchesArray) {
      return new Date(
        Number(matchesArray[1]),
        Number(matchesArray[2]) - 1,
        Number(matchesArray[3]),
        Number(matchesArray[4]),
        Number(matchesArray[5]),
        Number(matchesArray[6])
      );
    } else {
      return undefined;
    }
  }

  static getDayOfMonth(date: Date) {
    return date.getDate();
  }

  static getMonthAsString(date: Date) {
    switch (date.getMonth()) {
      case 0:
        return "jan";
      case 1:
        return "feb";
      case 2:
        return "maa";
      case 3:
        return "apr";
      case 4:
        return "mei";
      case 5:
        return "jun";
      case 6:
        return "jul";
      case 7:
        return "aug";
      case 8:
        return "sep";
      case 9:
        return "okt";
      case 10:
        return "nov";
      case 11:
        return "dec";
    }
  }

  static getHours(timeStamp: Date) {
    return timeStamp.getHours() + 1;
  }

  static parseDate(date: string) {
    const parts = date.split('-').map(p => Number(p));
    return new Date(parts[0], parts[1] - 1, parts[2]);
  }

  static getNumberOfDaysInWeekLeft(date: Date) {
    return date.getDay() == 0 ? 1 : 7 - date.getDay();
  }

  static isInRange(date: Date, startAsDaysFromNow: number, endAsDaysFromNowExclusive: number) {
    let date1 = date;
    let date2 = DateUtils.getNowAsDate();
    const diff = DateUtils.daysDiff(date2, date1);
    return (date1 >= date2) && (diff >= startAsDaysFromNow) && (diff < endAsDaysFromNowExclusive);
  }
}
